import React, { useState } from 'react';

// onUnavailable: sign-ups aren't stored yet, so the page explains that instead of faking success
export const PerformanceAlertsBanner = ({ eyebrow, onUnavailable }) => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onUnavailable('IPO alert sign-ups are coming soon. Your email address was not saved.');
  };

  return (
    <section
      aria-labelledby="performance-alerts-heading"
      className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-slate-950 via-[#062b2b] to-[#005c5c] text-white p-6 sm:p-8 shadow-elevated"
    >
      <div aria-hidden="true" className="absolute -right-16 -top-24 w-80 h-80 rounded-full bg-teal-300/10 blur-2xl" />
      <div className="relative flex flex-col lg:flex-row lg:items-center justify-between gap-6">
        <div className="max-w-2xl">
          <span className="inline-flex px-2.5 py-1 rounded-full border border-teal-300/40 bg-teal-400/10 text-[10px] font-extrabold uppercase tracking-widest text-teal-100">
            {eyebrow}
          </span>
          <h2 id="performance-alerts-heading" className="mt-3 text-xl sm:text-2xl font-extrabold tracking-tight">
            Stay Ahead with Live Allotment &amp; GMP Trackers
          </h2>
          <p className="mt-2 text-sm text-slate-300 leading-relaxed">
            Get instant WhatsApp &amp; Email alerts for Grey Market Premiums (GMP), subscription figures (QIB, NII, Retail),
            and real-time registrar status.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2 w-full lg:w-auto lg:min-w-[440px]">
          <label htmlFor="performance-alerts-email" className="sr-only">
            Email address
          </label>
          <input
            id="performance-alerts-email"
            type="email"
            required
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address"
            className="flex-1 min-w-0 px-4 py-2.5 rounded-xl border border-white/15 bg-white/5 text-sm text-white placeholder-slate-400 focus:outline-none focus:border-teal-300 focus:ring-1 focus:ring-teal-300"
          />
          <button
            type="submit"
            className="px-5 py-2.5 rounded-xl bg-[#008080] hover:bg-[#009696] text-sm font-bold text-white shadow-md shadow-black/20 transition-colors"
          >
            Subscribe Free
          </button>
        </form>
      </div>
    </section>
  );
};

export default PerformanceAlertsBanner;
